module.exports = __webpack_public_path__ + "img/bakingIngredient11.fbda85b5.jpeg";